import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  subtitleWithLines: {
    // Typography
    fontSize: '2rem',
    lineHeight: '2.8rem',
    letterSpacing: '0.028rem',
    fontWeight: 700,
    textAlign: 'center',
    color: colors.neutral[900],

    // Layout
    position: 'relative',
    overflow: 'hidden',
    margin: '2rem 0',
  },

  subtitleText: {
    display: 'inline-block',
    verticalAlign: 'baseline',
    position: 'relative',
    padding: '0 1rem',

    // Lines
    '&::before, &::after': {
      content: "''",
      display: 'block',
      width: '40rem',
      position: 'absolute',
      top: '50%',
      borderTop: `0.1rem solid ${colors.neutral[300]}`,
    },

    '&::before': {
      right: '100%',
    },

    '&::after': {
      left: '100%',
    },
    '@media(max-width:450px)': {
      padding: 0,
      '&::before, &::after': {
        display: 'none',
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
